import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-upload-csv-modal',
  templateUrl: './upload-csv-modal.component.html',
  styleUrls: ['./upload-csv-modal.component.scss'],
})
export class UploadCsvModalComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<UploadCsvModalComponent>,
  ) { }

  ngOnInit() {
  }

  uploadEmployees(files) {
    this.dialogRef.close(files);
  }

  close() {
    this.dialogRef.close();
  }
}
